<template>
  <div class="grid-3 grid-12-s">
    <div class="card column justify-space">
      <div class="title grid-12 column">
        Título
        <div class="city">{{ comm.titulo }}</div>
      </div>
      <div class="title grid-12 column">
        Mensagem
        <div class="city">{{ comm.mensagem }}</div>
      </div>
      <div class="title grid-12 column">
        Canais
        <div class="row">
          <div class="city">{{ comm.canais.join(", ") }}</div>
        </div>
      </div>
      <div class="grid-12 margin-top">
        <div class="column align-center">
          <div class="row wrap justify-center-m" v-if="comm.criado_em">
            <span>Criado em: &nbsp; &nbsp;</span>

            {{ comm.criado_em.slice(0, 10) | date }}
          </div>
          <div class="row wrap justify-center-m" v-else>
            <span>Criado em:</span> &nbsp;&nbsp;
            {{ new Date().toLocaleString("pt-BR").slice(0, 10) }}
          </div>

          <div class="row wrap justify-center-m">
            <span>Envio:</span>
            &nbsp;
            {{ comm.dh_agendamento_envio | date }}
          </div>
          <div class="row wrap justify-center-m">
            <span>&nbsp;Broadcast: &nbsp;</span>
            {{ comm.broadcast ? "Sim" : "Não" }} &nbsp;&nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
          </div>
        </div>
      </div>

      <div class="buttons grid-12 row column-s justify-center align-center">
        <router-link :to="'/funcionario/comunicado/supporter/' + comm.id">
          <Button layout="green-dark-p" class="grid-12-s">Editar</Button>
        </router-link>

        <Button layout="red-s" class="grid-12-s" @click="deleteComm">Excluir</Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { mapActions } from "vuex";
import Router from "@/router";

export default {
  components: {
    Button,
  },
  data() {
    return {
      router: Router,
    };
  },
  props: {
    comm: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("admin", ["DEL_COMM_SUPPORTER"]),
    deleteComm() {
      if (confirm("Deseja realmente excluir o comunicado?"))
        this.DEL_COMM_SUPPORTER(this.comm.id).then((r) => {
          if (r.status == 200) this.$emit("deleteComm", this.comm.id);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.card {
  background: $white;
  box-shadow: 0px 6px 16px #00000029;
  border-radius: 5px;
  color: $gray-1;
  padding: 25px;
  padding-top: 30px;
  margin-right: 30px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 40px;
  /* height: 285px; */

  .canceled {
    color: $red-2;
  }
  @media (max-width: $small) {
    margin-right: 20px;
  }
  .city {
    color: $gray-4;
    font-size: 13px;
    height: 30px;
    overflow-y: auto;
  }
  .title {
    color: $black;
    font-size: 17px;
    font-weight: bold;
    padding-bottom: 5px;
  }
  span {
    color: $gray-6;
    font-weight: 300;
  }
  .margin-top {
    margin-top: 16px;
  }
  .buttons {
    margin-top: 30px;

    .button-white-m {
      width: 38px;
      height: 35px;
      padding: 0px 10px;
      overflow: hidden;
      div {
        width: 180px;
        display: block;
      }
      img {
        margin-top: -4px;
      }
      &:hover {
        width: 215px;
        img {
          margin-top: 0px;
        }
      }
    }
    .button-white-green {
      max-width: 140px;
    }
    .button-green-dark-p {
      @media (max-width: $small) {
        width: 200px;
        margin-bottom: 10px;
      }
    }
    .button-red-s {
      width: 70px;
      margin-left: 12px;
      @media (max-width: $small) {
        margin-top: 10px;
        margin-left: 0px;
        width: 200px;
      }
    }
  }
}
</style>
